import { RotateCcw } from 'lucide-react';
import type { DateRange } from '../domain/models';

type DateRangeFilterProps = {
  range: DateRange;
  min?: string;
  max?: string;
  onChange: (range: DateRange) => void;
};

export function DateRangeFilter({ range, min, max, onChange }: DateRangeFilterProps) {
  return (
    <div className="date-filter">
      <div className="field">
        <label htmlFor="date-start">開始日</label>
        <input
          id="date-start"
          type="date"
          min={min}
          max={max}
          value={range.start ?? ''}
          onChange={(event) => onChange({ ...range, start: event.target.value || undefined })}
        />
      </div>
      <div className="field">
        <label htmlFor="date-end">終了日</label>
        <input
          id="date-end"
          type="date"
          min={min}
          max={max}
          value={range.end ?? ''}
          onChange={(event) => onChange({ ...range, end: event.target.value || undefined })}
        />
      </div>
      <button className="button" type="button" onClick={() => onChange({})}>
        <RotateCcw size={16} aria-hidden="true" />
        解除
      </button>
    </div>
  );
}
